module.exports = __webpack_public_path__ + "static/media/this-window.8dacdf61.png";